export const TRACKING_DATA_URL = 'vessel/tracking_data'
export const TRACKING_DATA_ERROR = 'TRACKING_DATA_ERROR'
export const TRACKING_DATA_LOADING = 'TRACKING_DATA_LOADING'
export const TRACKING_DATA_SUCCESS = 'TRACKING_DATA_SUCCESS'